import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PricingSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-foreground mb-4">Simple, Transparent Pricing</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We charge a one-time build fee for workflows. Optional maintenance plans available.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          
          {/* Starter */}
          <div className="p-8 bg-card rounded-2xl border border-border shadow-sm flex flex-col">
            <h3 className="text-xl font-bold text-foreground">Starter Build</h3>
            <div className="my-4">
              <span className="text-4xl font-bold text-foreground">$997</span>
              <span className="text-muted-foreground text-sm"> / one-time</span>
            </div>
            <p className="text-sm text-muted-foreground mb-6">Best for simple tasks like form-to-email or basic CRM sync.</p>
            <ul className="space-y-3 mb-8 flex-1">
              {['Up to 3-step workflow', 'Standard Error Handling', '1 Week Support', 'Documentation'].map((feat, i) => (
                <li key={i} className="flex gap-2 text-sm text-foreground">
                  <Icon name="Check" size={16} className="text-primary" /> {feat}
                </li>
              ))}
            </ul>
            <Link to="/contact">
              <Button variant="outline" fullWidth>Get Started</Button>
            </Link>
          </div>

          {/* Growth - Highlighted */}
          <div className="p-8 bg-primary/5 rounded-2xl border-2 border-primary shadow-xl flex flex-col relative transform md:-translate-y-4">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide shadow-sm">
              Most Popular
            </div>
            <h3 className="text-xl font-bold text-primary">Complex Logic</h3>
            <div className="my-4">
              <span className="text-4xl font-bold text-foreground">$2,497</span>
              <span className="text-muted-foreground text-sm"> / one-time</span>
            </div>
            <p className="text-sm text-muted-foreground mb-6">For multi-step logic, API connections, and data formatting.</p>
            <ul className="space-y-3 mb-8 flex-1">
              {['Unlimited Steps', 'Custom API Integration', 'Advanced Error Routing', '30 Days Support', 'Video Training'].map((feat, i) => (
                <li key={i} className="flex gap-2 text-sm text-foreground">
                  <Icon name="Check" size={16} className="text-primary" /> {feat}
                </li>
              ))}
            </ul>
            <Link to="/contact">
              <Button variant="default" fullWidth>Select Plan</Button>
            </Link>
          </div>

          {/* Enterprise */}
          <div className="p-8 bg-card rounded-2xl border border-border shadow-sm flex flex-col">
            <h3 className="text-xl font-bold text-foreground">Retainer / Custom</h3>
            <div className="my-4">
              <span className="text-4xl font-bold text-foreground">Custom</span>
            </div>
            <p className="text-sm text-muted-foreground mb-6">For full business automation, AI agents, and ongoing support.</p>
            <ul className="space-y-3 mb-8 flex-1">
              {['Dedicated Engineer', 'SLA Guarantee', 'Monthly Audits', '24/7 Monitoring'].map((feat, i) => (
                <li key={i} className="flex gap-2 text-sm text-foreground">
                  <Icon name="Check" size={16} className="text-primary" /> {feat}
                </li>
              ))}
            </ul>
            <Link to="/contact">
              <Button variant="outline" fullWidth>Contact Sales</Button>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PricingSection;